import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as IconLoader } from '../../assets/icon/ic_loading.svg';
import BgCube from '../../assets/images/bg-cube.png';
import getPriorityCoOrders from '../../thunks/coilovers/orders/getPriorityCoOrders';

const WarningOrderWidget = () => {
  const dispatch = useDispatch();
  const { data, loading, total } = useSelector((state) => state?.getPriorityCoOrders);

  const getLink = () => DateTime.now()
    .minus({ days: 6 })
    .toISODate();

  const getStatuses = () => [
    'Ready asb',
    'Out of stock',
    'Out of reserve',
    'Part box',
    'Pack box',
    'New',
  ].join(',');

  useEffect(() => {
    if (!data.length) {
      dispatch(getPriorityCoOrders());
    }
  }, []);

  return (
    <Link
      to={`/coilovers/orders/?marketplaceDateTo=${getLink()}&orderStatus=${getStatuses()}`}
      target="_blank"
      className="block bg-no-repeat bg-[right_top_-1.7rem] bg-cover shadow-[0_3px_4px_0_#0d1b2a08]
      bg-danger rounded-[0.75rem] border border-[#f1f1f4] min-h-[150px] w-full p-[16px_20px]
      cursor-pointer no-underline"
      style={{
        backgroundImage: `url(${BgCube})`,
      }}
    >
      <div>
        <div className="text-white">
          <p className="text-[2.5rem] font-semibold">
            {loading ? (
              <IconLoader widht={100} height={50} className="spin" />
          ) : total}
          </p>
          <p className="opacity-75 text-[1.075rem] font-medium">
            High Priority Orders
          </p>
        </div>
      </div>
    </Link>
  );
};

export default WarningOrderWidget;
